import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


/* REUSABLE ROW COMPONENT */
function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      mb={2}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          width: '38%',
          flexShrink: 0,
          opacity: 0.9,
        }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          width: '60%',
          color: '#333',
          wordBreak: 'break-word',
        }}
      >
        : {value}
      </Typography>
    </Box>
  );
}

type IssueInfoProps = {
  open: boolean;
  onClose: () => void;
   IsFromPropsReceive?: boolean;
   IsFromReceive?: boolean;
  data: {
    indentNoDate?: string;
    prNoDate?: string;
    indentRemark?: string;
    issueRemark?: string;
    issueNoDate?: string;
    receiveRemark?: string;
    receivedNoDate?: string;
  } | null;
};

export default function   IssueInformationPopup({
  open,
  onClose,
  data,
  IsFromPropsReceive = false,
  IsFromReceive = false,
}: IssueInfoProps) {
  const { t: tStockTransfer } = useTranslation('stockTransfer_config');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '18px',
          paddingBottom: 2,
          width: '455px',
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle
        sx={{
          fontSize: '20px',
          fontWeight: 700,
          pb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #E3E3E3',
        }}
      >
        {tStockTransfer('More Information')}
        {(IsFromReceive ? data?.receivedNoDate : data?.issueNoDate) ? (
          <span style={{ fontSize: '14px', fontWeight: 500 }}>
            {' '}
            ({(IsFromReceive ? data?.receivedNoDate : data?.issueNoDate)?.split(' | ')[0]})
          </span>
        ) : null}

        <IconButton onClick={onClose} sx={{ color: '#666' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* BODY CONTENT */}
      <DialogContent sx={{ mt: 1 }}>
        {IsFromReceive && (
          <InfoRow label={tStockTransfer('Issue No. | Date')} value={data?.issueNoDate || '-'} />
        )}
        <InfoRow label={tStockTransfer('Indent No. | Date')} value={data?.indentNoDate || '-'} />
        <InfoRow label={tStockTransfer('PR No. | Date')} value={data?.prNoDate || '-'} />
        {!IsFromPropsReceive && !IsFromReceive && (
          <InfoRow label={tStockTransfer('Indent Remark')} value={data?.indentRemark || '-'} />
        )}
        <InfoRow label={tStockTransfer('Issue Remark')} value={data?.issueRemark || '-'} />
        {(IsFromReceive) && (
          <InfoRow label={tStockTransfer('Receive Remark')} value={data?.receiveRemark || '-'} />
        )}
      </DialogContent>
    </Dialog>
  );
}
